import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { AREAS } from "@/lib/constants";
import { fileUrl } from "@/lib/api";

export default function ProjectCard({ project, testId }) {
  const area = AREAS.find((a) => a.key === project.area);
  const cover = project.cover_image ? fileUrl(project.cover_image) : null;
  const statusBadge = project.status === "concluso"
    ? { text: "Concluso", cls: "bg-[#292522] text-white" }
    : project.status === "in_pausa"
    ? { text: "In pausa", cls: "bg-[#F8F1E8] text-[#292522]" }
    : { text: "Attivo", cls: "bg-[#FF6100] text-white" };
  return (
    <Link to={`/progetti/${project.slug}`} className="group card-vv block bg-[#F8F1E8] hover:-translate-y-1 transition-transform duration-300" data-testid={testId}>
      <div className="relative aspect-[16/10] overflow-hidden bg-[#FFF1E8]">
        {cover ? (
          <img src={cover} alt={project.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
        ) : (
          <div className="absolute inset-0">
            <div className="absolute -top-10 -right-10 w-56 h-56 blob-2 bg-[#FF6100]/25" />
            <div className="absolute bottom-4 left-4 w-24 h-24 blob bg-[#216B65]/30" />
          </div>
        )}
        <div className={`absolute top-4 right-4 rounded-full px-3 py-1 text-xs font-semibold ${statusBadge.cls}`} data-testid={`project-status-${project.status}`}>
          {statusBadge.text}
        </div>
        {area && (
          <span className="absolute top-4 left-4 rounded-full bg-white/90 backdrop-blur px-3 py-1 text-xs font-semibold text-[#216B65]">
            {area.short}
          </span>
        )}
      </div>
      <div className="p-6">
        <h3 className="text-xl font-display font-semibold text-[#292522] group-hover:text-[#FF6100] transition-colors">{project.title}</h3>
        {project.subtitle && <p className="mt-1 text-sm text-[#292522]/60 italic">{project.subtitle}</p>}
        {project.short_desc && <p className="mt-3 text-sm text-[#292522]/75 line-clamp-3">{project.short_desc}</p>}
        <div className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[#FF6100]">
          Scopri il progetto <ArrowRight className="h-4 w-4" strokeWidth={1.75} />
        </div>
      </div>
    </Link>
  );
}
